export default __webpack_public_path__ + "static/media/gallery-three.02b411fe.jpg";